import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import BaseTimeAgo from 'react-timeago';
import defaultFormatter from 'react-timeago/lib/defaultFormatter';

const WEEKS_IN_MONTH = 4.34812141;
const timeUnits = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w',
    month: 'mo',
    year: 'y',
};
function createLongDateFormatter(capitalizeNow) {
    const now = capitalizeNow ? 'Now' : 'now';
    const formatter = (...args) => {
        const [value, unit] = args;
        if ((value === 1 && unit === 'day') || (value === 24 && unit === 'hour'))
            return 'Yesterday';
        return unit === 'second' ? now : defaultFormatter(...args);
    };
    return formatter;
}
function createShortDateFormatter(showSuffix, capitalizeNow) {
    const now = capitalizeNow ? 'Now' : 'now';
    const formatter = (value, unit, suffix) => {
        if (unit === 'second')
            return now;
        let formattedDate;
        if (unit === 'month') {
            formattedDate = `${Math.round(value * WEEKS_IN_MONTH)}${timeUnits.week}`;
        }
        else {
            formattedDate = `${value}${timeUnits[unit]}`;
        }
        if (showSuffix) {
            return `${formattedDate} ${suffix}`;
        }
        return `${formattedDate}`;
    };
    return formatter;
}
const TimeAgo = (props) => {
    const { date, short = false, showShortDateSuffix = false, hideTitle = false, capitalizeNow = true } = props, otherProps = __rest(props, ["date", "short", "showShortDateSuffix", "hideTitle", "capitalizeNow"]);
    const formatter = short
        ? createShortDateFormatter(showShortDateSuffix, capitalizeNow)
        : createLongDateFormatter(capitalizeNow);
    return (jsx(BaseTimeAgo, Object.assign({ date: date, title: !hideTitle ? new Date(date).toLocaleString() : undefined, formatter: formatter }, otherProps)));
};

export { TimeAgo, createLongDateFormatter, createShortDateFormatter, timeUnits };
